import React from "react";

import styles from "./logo.css";

import logo from "./svg/logo.svg";

const Logo = () => {
  return (
    <a
      href="/"
      className={styles.logo}
      dangerouslySetInnerHTML={{ __html: logo }}
    />
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/ui/logo/logo.js